import React from 'react';
import Styles from "./modal.module.scss";
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { useWindowSize } from '../../effect/WindowSize';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  // width: '50%',
  overflow: 'auto',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

function ModalLayout(props) {
  let subtitle;
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const { width, height } = useWindowSize()

  function openModal() {
    setIsOpen(true);
  }

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    // subtitle.style.color = '#f00';
  }

  function closeModal() {
    setIsOpen(false);
  }
  return (
    <div class="row gy-3">
      {/* //   <div className="col-lg-4 col-md-6">
    //     <small className="text-light fw-semibold">Vertically centered</small>
    //     <div className="mt-3">
         
    //       <div className="modal fade" id={props.modalId} tabIndex={-1} aria-hidden="true">
    //         <div className="modal-dialog modal-dialog-centered" role="document">
    //           <div className="modal-content">
    //             <div className="modal-header">
    //               <h5 className="modal-title" id="modalCenterTitle">Modal title</h5>
    //               <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
    //             </div>
    //             <div className="modal-body">
    //               {props.content}
    //             </div>

    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div> */}
      <Modal
        open={props.modal}
        onAfterOpen={props.afterOpenModal}
        onClose={props.closeModal}
      // style={customStyles}
      // ariaHideApp={false}
      // overlayClassName={Styles.Overlay}
      // contentLabel="Example Modal"
      >
        <Box sx={[style, { bgcolor: props.backgroundColor, padding: props.padding, width: width<700?"80%":"50%" }]}>
          {props.content}
        </Box>

      </Modal>
    </div>
  );
}

export default ModalLayout;